// Minimum gap between forced JWT refresh attempts triggered by Knock's
// `tokenExpiring` callback. Prevents a thundering-herd refetch loop if Knock
// repeatedly reports an expiring token.
export const KNOCK_TOKEN_REFRESH_THROTTLE_MS = 60 * 1000;
